import axios from './axios'

export const crawlWix = (data) =>
  axios.post(`/jobs/recommend-crawl-wix-html`, data)